import PropTypes from 'prop-types';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import ClassicEnrollInWorkflowActionDetail from 'automation-ui-action-features/actions/classic-enroll-in-flow/ClassicEnrollInWorkflowActionDetail';
import ClassicEnrollInWorkflowActionMetadata from 'automation-ui-action-features/actions/classic-enroll-in-flow/ClassicEnrollInWorkflowActionMetadata';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicEnrollInWorkflowActionHistoryCard = ({
  actionMetadata,
  actionLabel
}) => {
  return /*#__PURE__*/_jsx(LogEventRowAction, {
    title: actionLabel,
    content: /*#__PURE__*/_jsx(ClassicEnrollInWorkflowActionDetail, {
      actionMetadata: actionMetadata
    })
  });
};
ClassicEnrollInWorkflowActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(ClassicEnrollInWorkflowActionMetadata).isRequired,
  actionLabel: PropTypes.node
};
export default ClassicEnrollInWorkflowActionHistoryCard;